export const ErrorTypes = {
  NETWORK_ERROR: "Network Error",
  UNAUTHORIZED: "Unauthorized",
  UNEXPECTED_ERROR: "normal",
  MAINTENANCE_ERROR: "maintenance",
};

